import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled || !isHome
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
            : 'bg-transparent'
        }`}
        role="navigation"
        aria-label="主导航"
      >
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap"
              aria-label="星辰影院首页"
            >
              <h1 className="font-heading text-xl md:text-2xl font-bold text-primary-500">
                星辰影院
              </h1>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/'
                    ? 'text-primary-500'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-white hover:text-primary-100'
                }`}
              >
                首页
              </Link>

              <div className="relative group">
                <button
                  className={`text-sm font-medium transition-colors whitespace-nowrap flex items-center gap-1 ${
                    scrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-white hover:text-primary-100'
                  }`}
                >
                  电影分类
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-down-s-line text-xs"></i>
                  </span>
                </button>
                <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  <div className="bg-background-50 rounded-lg border border-background-200/70 py-2 min-w-[180px]">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="block px-4 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-500 transition-colors whitespace-nowrap"
                      >
                        {cat.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </div>

              <Link
                to="/about"
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/about'
                    ? 'text-primary-500'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-primary-500'
                      : 'text-white hover:text-primary-100'
                }`}
              >
                关于我们
              </Link>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="打开菜单"
            >
              <i
                className={`text-xl ${
                  scrolled || !isHome ? 'text-foreground-800' : 'text-white'
                } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
              ></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/60">
            <div className="px-4 py-3 space-y-1">
              <Link
                to="/"
                className="block py-3 px-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap"
              >
                首页
              </Link>
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="block py-3 px-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="block py-3 px-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap"
              >
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}